/* Localizes the Klaviyo reviews widget into Icelandic (skipped in EN mode). */
(function () {
  "use strict";
  function isEN() {
    try { return localStorage.getItem("wol-lang") === "en"; } catch (e) { return false; }
  }
  var MAP = {
    "Customer reviews": "Umsagnir viðskiptavina",
    "Reviews": "Umsagnir",
    "Questions": "Spurningar",
    "Write a review": "Skrifa umsögn",
    "Most relevant": "Mest viðeigandi",
    "Most recent": "Nýjast",
    "Newest": "Nýjast",
    "Oldest": "Elst",
    "Highest rating": "Hæsta einkunn",
    "Lowest rating": "Lægsta einkunn",
    "All ratings": "Allar einkunnir",
    "With media": "Með myndum",
    "Verified buyer": "Staðfest kaup",
    "Verified Buyer": "Staðfest kaup",
    "Incentivized": "Með hvata",
    "Store replied": "Verslunin svaraði",
    "No reviews yet": "Engar umsagnir enn",
    "Be the first to write a review": "Vertu fyrst til að skrifa umsögn",
    "No matching reviews": "Engar umsagnir fundust",
    "Try another search, or clear some filters": "Prófaðu aðra leit eða hreinsaðu síur",
    "Clear all filters": "Hreinsa allar síur",
    "Clear all": "Hreinsa allt",
    "Clear": "Hreinsa",
    "Show more": "Sjá fleiri",
    "Show less": "Sjá minna",
    "Load more": "Sjá fleiri",
    "Read more": "Lesa meira",
    "Read less": "Lesa minna",
    "Helpful": "Hjálplegt",
    "Report": "Tilkynna"
  };
  var ARIA = {
    "Write a review, opens in a new tab": "Skrifa umsögn, opnast í nýjum flipa",
    "Product Reviews and Questions tabs": "Flipar fyrir umsagnir og spurningar",
    "Search": "Leita",
    "Search reviews": "Leita í umsögnum",
    "Sort by:": "Raða eftir:",
    "Filter by:": "Sía eftir:",
    "Sort by": "Raða eftir",
    "Filter by": "Sía eftir"
  };
  function ago(s) {
    var m = s.match(/^(\d+)\s+(day|days|week|weeks|month|months|year|years)\s+ago$/);
    if (!m) return null;
    var n = +m[1], u = m[2];
    if (u.indexOf("day") === 0) return "fyrir " + n + (n === 1 ? " degi" : " dögum");
    if (u.indexOf("week") === 0) return "fyrir " + n + (n === 1 ? " viku" : " vikum");
    if (u.indexOf("month") === 0) return "fyrir " + n + (n === 1 ? " mánuði" : " mánuðum");
    return "fyrir " + n + (n === 1 ? " ári" : " árum");
  }
  function reviewsCount(s) {
    var m = s.match(/^(\d+)\s+reviews?$/);
    if (!m) return null;
    return m[1] + (+m[1] === 1 ? " umsögn" : " umsagnir");
  }
  function starLabel(s) {
    var m = s.match(/^(\d+)\s+stars?$/);
    if (!m) return null;
    return m[1] + (+m[1] === 1 ? " stjarna" : " stjörnur");
  }
  function aria(v) {
    var m;
    if (ARIA[v]) return ARIA[v];
    m = v.match(/^Average rating is ([\d.,]+) stars?$/);
    if (m) return "Meðaleinkunn er " + m[1] + " stjörnur";
    m = v.match(/^(\d+) reviews? with (\d+) stars?$/);
    if (m) return m[1] + (+m[1] === 1 ? " umsögn" : " umsagnir") + " með " + m[2] + (+m[2] === 1 ? " stjörnu" : " stjörnum");
    m = v.match(/^(\d+) star review$/);
    if (m) return "Umsögn með " + m[1] + (+m[1] === 1 ? " stjörnu" : " stjörnum");
    return null;
  }
  function fixAria(el) {
    var v = el.getAttribute("aria-label");
    if (!v) return;
    var r = aria(v.trim());
    if (r) el.setAttribute("aria-label", r);
  }
  function swap(root) {
    if (isEN()) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var t;
    while ((t = walker.nextNode())) {
      var key = t.textContent.trim();
      if (!key) continue;
      var rep = MAP[key] || ago(key) || reviewsCount(key) || starLabel(key);
      if (rep) t.textContent = t.textContent.replace(key, rep);
    }
    if (root.nodeType === 1 && root.hasAttribute("aria-label")) fixAria(root);
    if (root.querySelectorAll) {
      var labelled = root.querySelectorAll("[aria-label]");
      for (var i = 0; i < labelled.length; i++) fixAria(labelled[i]);
      root.querySelectorAll("input[placeholder]").forEach(function (i) {
        if (/search reviews/i.test(i.placeholder)) i.placeholder = "Leita í umsögnum";
      });
    }
  }
  function boot() {
    var host = document.getElementById("klaviyo-product-reviews-wrapper") || document.body;
    swap(host);
    var mo = new MutationObserver(function (muts) {
      for (var m of muts) {
        if (m.type === "characterData") {
          if (m.target.parentNode) swap(m.target.parentNode);
          continue;
        }
        for (var n of m.addedNodes) {
          if (n.nodeType === 1) swap(n);
          else if (n.nodeType === 3 && n.parentNode) swap(n.parentNode);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
